import { StyleControlType } from "../controls/style";
import {
  getElementChildren,
  getFileIds,
  getPageIds,
  getSwatchIds,
  getTypographyIds
} from "./introspection";
const Types = {
  Backgrounds: "Backgrounds",
  Border: "Border",
  BorderRadius: "BorderRadius",
  Checkbox: "Checkbox",
  Date: "Date",
  ElementID: "ElementID",
  Font: "Font",
  GapX: "GapX",
  GapY: "GapY",
  Grid: "Grid",
  Image: "Image",
  Images: "Images",
  Link: "Link",
  List: "List",
  Margin: "Margin",
  NavigationLinks: "NavigationLinks",
  Number: "Number",
  Padding: "Padding",
  ResponsiveColor: "ResponsiveColor",
  ResponsiveIconRadioGroup: "ResponsiveIconRadioGroup",
  ResponsiveLength: "ResponsiveLength",
  ResponsiveNumber: "ResponsiveNumber",
  ResponsiveOpacity: "ResponsiveOpacity",
  ResponsiveSelect: "ResponsiveSelect",
  RichText: "RichText",
  Shadows: "Shadows",
  Shape: "Shape",
  SocialLinks: "SocialLinks",
  Table: "Table",
  TableFormFields: "TableFormFields",
  Typeahead: "Typeahead",
  TextArea: "TextArea",
  TextInput: "TextInput",
  TextStyle: "TextStyle",
  Video: "Video",
  Width: "Width",
  Style: StyleControlType
};
function Backgrounds(options = {}) {
  return { type: Types.Backgrounds, version: 1, options };
}
const BorderPropControllerFormat = {
  ClassName: "makeswift::prop-controllers::border::format::class-name",
  ResponsiveValue: "makeswift::prop-controllers:border::format::responsive-value"
};
function Border(options = {}) {
  return { type: Types.Border, options };
}
Border.Format = BorderPropControllerFormat;
const BorderRadiusPropControllerFormat = {
  ClassName: "makeswift::prop-controllers::border-radius::format::class-name",
  ResponsiveValue: "makeswift::prop-controllers::border-radius::format::responsive-value"
};
function BorderRadius(options = {}) {
  return { type: Types.BorderRadius, options };
}
BorderRadius.Format = BorderRadiusPropControllerFormat;
function Checkbox(options) {
  return { type: Types.Checkbox, options };
}
function Date(options = {}) {
  return { type: Types.Date, options };
}
function ElementID(options = {}) {
  return { type: Types.ElementID, options };
}
function Font(options = {}) {
  return { type: Types.Font, options };
}
function GapX(options = {}) {
  return { type: Types.GapX, options };
}
function GapY(options = {}) {
  return { type: Types.GapY, options };
}
function Grid(options = {}) {
  return { type: Types.Grid, options };
}
function mergeGridPropControllerTranslatedData(data, context) {
  return {
    ...data,
    elements: data.elements.map((element) => context.mergeTranslatedData(element))
  };
}
function Image(options = {}) {
  return { type: Types.Image, version: 1, options };
}
function Images(options = {}) {
  return { type: Types.Images, version: 1, options };
}
function Link(options = {}) {
  return { type: Types.Link, options };
}
function List(options) {
  return { type: Types.List, options };
}
function introspectListPropControllerData(descriptor, value, func) {
  if (value == null)
    return [];
  return value.flatMap((item) => item.value ? func(descriptor.options.type, item.value) : []);
}
function getListPropControllerElementChildren(descriptor, value) {
  return introspectListPropControllerData(descriptor, value, getElementChildren);
}
function getListPropControllerSwatchIds(descriptor, value) {
  return introspectListPropControllerData(descriptor, value, getSwatchIds);
}
function getListPropControllerFileIds(descriptor, value) {
  return introspectListPropControllerData(descriptor, value, getFileIds);
}
function getListPropControllerTypographyIds(descriptor, value) {
  return introspectListPropControllerData(descriptor, value, getTypographyIds);
}
function getListPropControllerPageIds(descriptor, value) {
  return introspectListPropControllerData(descriptor, value, getPageIds);
}
const MarginPropControllerFormat = {
  ClassName: "makeswift::prop-controllers::margin::format::class-name",
  ResponsiveValue: "makeswift::prop-controllers::margin::format::responsive-value"
};
function Margin(options = {}) {
  return { type: Types.Margin, options };
}
Margin.Format = MarginPropControllerFormat;
function NavigationLinks(options = {}) {
  return { type: Types.NavigationLinks, options };
}
function Number(options = {}) {
  return { type: Types.Number, options };
}
const PaddingPropControllerFormat = {
  ClassName: "makeswift::prop-controllers::padding::format::class-name",
  ResponsiveValue: "makeswift::prop-controllers::padding::format::responsive-value"
};
function Padding(options = {}) {
  return { type: Types.Padding, options };
}
Padding.Format = PaddingPropControllerFormat;
function ResponsiveColor(options = {}) {
  return { type: Types.ResponsiveColor, options };
}
function ResponsiveIconRadioGroup(options) {
  return { type: Types.ResponsiveIconRadioGroup, options };
}
function ResponsiveLength(options = {}) {
  return { type: Types.ResponsiveLength, options };
}
function ResponsiveNumber(options = {}) {
  return { type: Types.ResponsiveNumber, options };
}
function ResponsiveOpacity(options = {}) {
  return { type: Types.ResponsiveOpacity, options };
}
function ResponsiveSelect(options) {
  return { type: Types.ResponsiveSelect, options };
}
function RichText(options = {}) {
  return { type: Types.RichText, options };
}
const ShadowsPropControllerFormat = {
  ClassName: "makeswift::prop-controllers::shadows::format::class-name",
  ResponsiveValue: "makeswift::prop-controllers::shadows::format::responsive-value"
};
function Shadows(options = {}) {
  return { type: Types.Shadows, options };
}
Shadows.Format = ShadowsPropControllerFormat;
function Shape(options) {
  return { type: Types.Shape, options };
}
function introspectShapePropControllerData(descriptor, value, func) {
  if (value == null)
    return [];
  return Object.entries(descriptor.options.type).flatMap(
    ([key, definition]) => func(definition, value[key])
  );
}
function getShapePropControllerElementChildren(descriptor, value) {
  return introspectShapePropControllerData(descriptor, value, getElementChildren);
}
function getShapePropControllerFileIds(descriptor, value) {
  return introspectShapePropControllerData(descriptor, value, getFileIds);
}
function getShapePropControllerTypographyIds(descriptor, value) {
  return introspectShapePropControllerData(descriptor, value, getTypographyIds);
}
function getShapePropControllerPageIds(descriptor, value) {
  return introspectShapePropControllerData(descriptor, value, getPageIds);
}
function getShapePropControllerSwatchIds(descriptor, value) {
  return introspectShapePropControllerData(descriptor, value, getSwatchIds);
}
const socialLinkTypesV0 = [
  "angellist",
  "codepen",
  "discord",
  "dribbble",
  "facebook",
  "github",
  "instagram",
  "linkedin",
  "medium",
  "pinterest",
  "reddit",
  "rss",
  "snapchat",
  "soundcloud",
  "spotify",
  "telegram",
  "tumblr",
  "twitch",
  "twitter",
  "vimeo",
  "whatsapp",
  "yelp",
  "youtube"
];
const socialLinkTypesV1 = [...socialLinkTypesV0, "x", "slack"];
function SocialLinks(options = {}) {
  return { type: Types.SocialLinks, options, version: 1 };
}
function Table(options = {}) {
  return { type: Types.Table, options };
}
function TableFormFields(options = {}) {
  return { type: Types.TableFormFields, options };
}
function Typeahead(options) {
  return { type: Types.Typeahead, options };
}
function TextArea(options = {}) {
  return { type: Types.TextArea, options };
}
function TextInput(options = {}) {
  return { type: Types.TextInput, options };
}
function TextStyle(options = {}) {
  return { type: Types.TextStyle, options };
}
function Video(options = {}) {
  return { type: Types.Video, options };
}
const WidthPropControllerFormat = {
  ClassName: "makeswift::prop-controllers::width::format::class-name",
  ResponsiveValue: "makeswift::prop-controllers::width::format::responsive-value"
};
function Width(options = {}) {
  return { type: Types.Width, options };
}
Width.Format = WidthPropControllerFormat;
export {
  Backgrounds,
  Border,
  BorderPropControllerFormat,
  BorderRadius,
  BorderRadiusPropControllerFormat,
  Checkbox,
  Date,
  ElementID,
  Font,
  GapX,
  GapY,
  Grid,
  Image,
  Images,
  Link,
  List,
  Margin,
  MarginPropControllerFormat,
  NavigationLinks,
  Number,
  Padding,
  PaddingPropControllerFormat,
  ResponsiveColor,
  ResponsiveIconRadioGroup,
  ResponsiveLength,
  ResponsiveNumber,
  ResponsiveOpacity,
  ResponsiveSelect,
  RichText,
  Shadows,
  ShadowsPropControllerFormat,
  Shape,
  SocialLinks,
  Table,
  TableFormFields,
  TextArea,
  TextInput,
  TextStyle,
  Typeahead,
  Types,
  Video,
  Width,
  WidthPropControllerFormat,
  getListPropControllerElementChildren,
  getListPropControllerFileIds,
  getListPropControllerPageIds,
  getListPropControllerSwatchIds,
  getListPropControllerTypographyIds,
  getShapePropControllerElementChildren,
  getShapePropControllerFileIds,
  getShapePropControllerPageIds,
  getShapePropControllerSwatchIds,
  getShapePropControllerTypographyIds,
  introspectListPropControllerData,
  introspectShapePropControllerData,
  mergeGridPropControllerTranslatedData,
  socialLinkTypesV0,
  socialLinkTypesV1
};
//# sourceMappingURL=descriptors.js.map